import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'
import { statelessFunctionNameToKebab } from '../utils/toKebabCase'

type Props = {
  numberOfUsers: number,
  isOpen: boolean,
  onSend: () => void,
  onClose: () => void
}

const SendEmailCampaignConfirmationModal = ({ numberOfUsers, isOpen, onSend, onClose }: Props) => {
  return <Modal isOpen={isOpen} size='small'>
    <ModalHeader title='Ready to send this email campaign?' onClose={() => onClose()} />
    <ModalBody>
      <div className={statelessFunctionNameToKebab(SendEmailCampaignConfirmationModal.name)}>
        <p>Your email will be sent to <span className='bold'>{numberOfUsers} users</span> immediately. There’s no turning back once the emails are sent.</p>
      </div>
    </ModalBody>
    <ModalFooter>
      <ButtonControl
        title='Yes, send email now'
        newStyle
        onClick={onSend}
        size='medium'
        variant='brand'
        class='qa-send-email-campaign'
      />
      <ButtonControl
        title='Cancel'
        newStyle
        onClick={onClose}
        size='medium'
      />
    </ModalFooter>
  </Modal>
}

export default SendEmailCampaignConfirmationModal
